import React from 'react';
import Marquee from "react-fast-marquee";
import './Testimonials.css';

const testimonials = [
  {
    author: "Community",
    text: "Elaichi & Love is simply soul in a cup. The karak chai is the hug your gut's been waiting for - authentic, spicy, and made with real ingredients. Sticky Soul balls are magic: just add hot water and you're in Mumbai. This is wellness that actually tastes good."
  },
  {
    author: "Wellness seeker",
    text: "Pop & Bloom lotus seeds and the trail mixes are my go-to. High protein, gut-friendly, and no guilt. The Berry Banger shot is a perfect pick-me-up. Finally, snacks that fuel you without the crash. E&L gets it."
  },
  {
    author: "Chai lover",
    text: "The best karak chai I've had outside India. You can tell it's a family recipe - cardamom, ginger, the works. The subscription box is a conversation starter every month. Love what they're building: community through chai."
  },
  {
    author: "Founder",
    text: "Power Hour and Think Tank mixes got me through launch week. Proper fuel, no junk. And the Chai & Connect workshop was brilliant for the team - we learned, we sipped, we connected. Elaichi & Love is the real deal."
  },
  {
    author: "Glasgow local",
    text: "From pop-ups to the weekly ritual box - everything is thoughtful and delicious. The Heritage Tiffin and Ritual Jar are now part of my daily flow. Sustainable, fresh, mindful. So glad they're here."
  },
  {
    author: "Event host",
    text: "We had E&L for our Iftar and it was unforgettable. The chai, the snacks, the warmth. They didn't just serve drinks - they brought a whole vibe. Book them for your next event. You won't regret it."
  }
];

function Testimonials() {
  return (
    <div className="testimonials-container">
      <Marquee speed={150} pauseOnHover={true}>
        <div className="testimonials-track">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className={`testimonial-card ${index % 2 === 0 ? 'bg1' : 'bg2'}`}
            >
              <div className="testimonial-content">
                <p>
                  <span className="quote">❛❜</span>
                  <br/>
                  {item.text}
                </p>
                <div style={{color : 'white'}} className="publication-name">
                  {item.author}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Marquee>
    </div>
  );
}

export default Testimonials;
